
<template>
<div>
  <form class="">
    <div class="mb-4">
      <label class="form-label">Email or Phone Mobile</label>
      <input type="text" v-model="data.other_key" :class="{ 'is-invalid': v$.data.other_key.$error }" 
      class="form-control" placeholder="Enter email or phone number" @keyup.enter="submitData">
      
      <div v-for="(item, index) in v$.data.other_key.$errors"
        :key="index" class="invalid-feedback">
        <span v-if="item.$message">{{ item.$message }}</span>
      </div>
    </div>
    <div class="mb-4">
      <div class="float-end">
        <a :href="absoluteUrl('/forgot-password')" class="text-muted">Forgot password?</a>
      </div>
      <label class="form-label" for="password-input">Password</label>
      <div class="position-relative auth-pass-inputgroup mb-3">
        <input :type="passwordType" class="form-control pe-5 password-input" 
        v-model="data.password" name="password" @keyup.enter="submitData"
        :class="{ 'is-invalid':  v$.data.password.$error }"
        placeholder="Enter password" id="password-input">
        <button @click="passwordVisibility()" class="btn btn-link position-absolute
        end-0 top-0 text-decoration-none shadow-none text-muted password-addon"
        type="button" id="password-addon">
        <i :class="passwordType == 'text'? 'ri-eye-off-fill': 'ri-eye-fill'" class="align-middle"></i></button>
      </div>
      <div v-if="v$.data.password.$error"
        class="text-danger">
        <span v-if="v$.data.password.required.$message">{{
          v$.data.password.required.$message }}</span>
      </div>
    </div>
    <div class="mb-3 font-13 d-flex justify-content-between">
      <div class="form-check">
        <input v-model="data.remember" type="checkbox" id="remember" class="form-check-input">
        <label for="remember" class="form-check-label fs-base">Remember me</label>
      </div>
    </div>
    <div class="d-grid mb-4">
      <button @click.prevent="submitData()" class="btn btn-primary"  type="button">
          Sign In
      </button>
    </div>
  </form>
</div>
</template>
<script>
import { required, email, helpers, minLength } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default {
  name: 'user-login-form',
  setup() {
    return { v$: useVuelidate() };
  },
  validations: {
    data:{
      other_key: {
        required: helpers.withMessage("Email or phone number is required", required),
        emailOrMobile: helpers.withMessage(
            "Enter a valid email or phone number",
            (value) => {
                if (!value) return false;
                value = value.trim();
                const emailValid = email.$validator(value);

                const mobileRegex = /^0\d{10}$/;
                const mobileValid = mobileRegex.test(value);

                return emailValid || mobileValid;
            }
        )
      },
      password: {
        required: helpers.withMessage("Password is required", required),
        minLength: helpers.withMessage(
            "Password should not be less than 6 characters",
            minLength(6)
        ),
      },
    }
  },
  data() {
    return {
      data: {
        other_key: '',
        password: '',
        remember: true
      },
      passwordType: "password",
    }
  },
  methods: {
    passwordVisibility(){
      this.passwordType == "password" ? this.passwordType = "text" : this.passwordType = "password"
    },
    submitData(){
      this.v$.$validate().then(result =>{
        if (!result) { this.alertError(this.v$.$errors[0].$message); return;}
        this.$store.dispatch("changeLoaderValue", true)
        let formData = new FormData();
        formData.append('data', JSON.stringify(this.data));
        this.$http.post("/login", formData)
        .then((response)=> {
          this.$store.dispatch("changeLoaderValue")
          if(response.data.success){
            this.takeAction(response.data.data)
          }
        })
      });        
    },
    takeAction(data){
      this.resetForm()
      this.$emit("takeAction", {...data})
    },
    resetForm(){
      this.data = {
        other_key: '',
        password: '',
        remember: true
      }
      this.v$.$reset()
    },
   },
  }
</script>

<style lang="scss">

</style>
